import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export default new (class {
	async getAll() {
		const response = await axios.get(`${API_URL}/api/Cms/LifeEvents`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async getById(lifeEvent_ID) {
		const url = lifeEvent_ID
			? `/api/Cms/LifeEvent?id=${lifeEvent_ID}`
			: '/api/Cms/LifeEvent';

		const response = await axios.get(`${API_URL}${url}`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async update(LifeEventsData) {
		try {
			await axios.put(`${API_URL}/api/Cms/LifeEvent`, LifeEventsData, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error updating lifestyle question:', error);
			throw error;
		}
	}
	async deleteById(lifeEvent_ID) {
		try {
			await axios.delete(`${API_URL}/api/Cms/LifeEvent?id=${lifeEvent_ID}`, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error deleting by ID:', error);
			throw error;
		}
	}
})();
